import LoadingAction from "@common/redux/actions/LoadingAction";
import AlertModalAction from "@common/redux/actions/AlertModalAction";
import logOut from "@common/components/helpers/logout";

/**
 * Generic Error Handler for failed API requests
 * @param {AxiosError} error
 */

export const handleError = (
  error,
  title = "Error",
  message = "There was an error completing your request to the server, please try again.",
  onClose = () => {},
) => {
  if (error.response) {
    if (error.response.status === 401) {
      message =
        "There was an error authenticating your login session, please login again.";
      onClose = () => logOut();
    } else {
      if (
        typeof error.response.data === "string" &&
        error.response.data.length > 0
      ) {
        message = error.response.data;
      } else {
        if (
          error.response.data.detail &&
          error.response.data.detail.length > 0
        ) {
          message = error.response.data.detail;
        }
      }
    }
  }

  const titleWithStatus = `${title}: ${error?.response?.status}`;

  LoadingAction.set(false).then(() =>
    AlertModalAction.open(
      message,
      titleWithStatus,
      error?.response?.status === 401
        ? () => (window.location = "/?expired=1")
        : onClose,
    ),
  );
};
